import { NotificationDetail } from './NotificationDetail'
import { WizardStep } from 'app-view/components/Wizard'

export const SYSTEMNOTIFICATION_STEPS: WizardStep[] = [
  {
    name: 'notification-detail',
    component: NotificationDetail,
  },
]
